module.exports = __webpack_public_path__ + "static/img/julibigornia_circle150.2e52af7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/experts/julibigornia_circle150.png
// module id = lZ2f
// module chunks = 0